import AddIcon from "@mui/icons-material/Add";
import { IconButton, Tooltip } from "@mui/material";

const CustomGridToolbarAddButton = ({
  onAdd,
  title = "Add",
}: {
  onAdd?: () => void;
  title?: string;
}) => {
  if (!onAdd) return;

  return (
    <Tooltip title={title}>
      <IconButton onClick={onAdd}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
};

export default CustomGridToolbarAddButton;
